import { render, staticRenderFns } from "./HeaderGameInformation.vue?vue&type=template&id=23e2aef0&"
import script from "./HeaderGameInformation.vue?vue&type=script&lang=js&"
export * from "./HeaderGameInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports